import React from 'react';

import { BudgetBys } from 'business/constants';
import ResourceLocker from 'routes/BudgetModule/components/shared/Locker/ResourcelLocker';
import { Box } from '@mui/system';

interface LockerCellRendererProps {
    value: string;
    by: BudgetBys;
    rights?: string[];
}

/**
 * Cell renderer for displaying a lock or unlock icon based on the rights of the gestionnaire or services to update the BP.
 * We cannot use the <BudgetProposalLocker> component directly because we need a wrapper for centering in the cell.
 */
export const LockerCellRenderer: React.FC<LockerCellRendererProps> = (
    props,
) => {
    const { value, by, rights } = props;
    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <ResourceLocker
                resourceSoftwareId={value}
                rights={rights}
                by={by}
            />
        </Box>
    );
};
